// extracted by mini-css-extract-plugin
export default {"list-tab":"tab-wallet_list-tab__cwZ-e","item-tab":"tab-wallet_item-tab__BoO42","icon":"tab-wallet_icon__nfl8Z","item-active":"tab-wallet_item-active__IyimI"};